import type { BrainStatus, PredictionsAccuracyResponse, ProposalsResponse } from '../types';
import { apiFetch } from '../http';

export function getBrainStatus(): Promise<BrainStatus> {
  return apiFetch<BrainStatus>('/omega/brain/status');
}

export function getProposals(): Promise<ProposalsResponse> {
  return apiFetch<ProposalsResponse>('/omega/proposals');
}

export function getPredictionsAccuracy(): Promise<PredictionsAccuracyResponse> {
  return apiFetch<PredictionsAccuracyResponse>('/omega/brain/predictions/accuracy');
}
